<template>
  <div class="find-insights-container">
    <div v-if="isLoading">
      <Spinner :is-loading="isLoading" message="Refreshing chart" complete-message="" />
    </div>
    <button @click="analysisSummary()" class="find-insights-button">
      <img
        :src="'/assets/insight_generate.png'"
        :alt="`Generate insights icon`"
        class="find-insights-icon"
      />
      <div class="find-insights-label">
        <VisibleText> Insights </VisibleText>
      </div>
    </button>
  </div>
</template>

<script>
// Services
import AutoService from '@/services/autoService.js';
// Mixins
import UserMixin from '@/utils/mixins/userMixin.js';
import ProjectMixin from '@/components/Project/Mixins/projectMixin.js';
import ProjectReportMixin from '@/components/Project/Mixins/projectReportMixin.js';
// Utils
import { fetchProject } from '@/components/Project/Utils/fetch.js';

export default {
  name: 'FindInsightsButton',
  mixins: [UserMixin, ProjectMixin, ProjectReportMixin],
  data() {
    return {
      AUTO_SERVICE: new AutoService(this.$pigeonline),
      isLoading: false,
    };
  },
  methods: {
    async analysisSummary() {
      // TODO replace with one that is specific to the analysis that pressed this
      this.isLoading = true;
      await this.AUTO_SERVICE.analysisSummary({
        project_id: this.project.id,
        include_recommendations: true,
      });
      const fullProject = await fetchProject(this.project.id);
      await this.saveProject(fullProject);
      this.$emit('refresh_for_insights');
    },
  },
};
</script>
